import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    provideZoneChangeDetection,
    ErrorHandler,
    LOCALE_ID,
} from '@angular/core';
import { createErrorHandler } from '@sentry/angular';
import {
    PreloadAllModules,
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withPreloading,
    withRouterConfig,
    withViewTransitions,
} from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';

import { routes } from './app.routes';
import {
    provideClientHydration,
    withEventReplay,
    withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
    provideIcons,
    provideNgIconLoader,
    provideNgIconsConfig,
    withCaching,
} from '@ng-icons/core';
import { ICONS } from './layout/data/icons.data';
import { AuthInterceptor } from './common/http-interceptors/header.interceptor';
import { PageBuilderService } from './layout/services/page-builder.service';
import { LayoutBuilderService } from './layout/services/layout-builder.service';
import { PolygonHandlerService } from './layout/services/polygon-handler.service';
import { PolygonLoopSeparatorService } from './layout/services/polygon-separator.service';
import { DatePipe } from '@angular/common';
import { InteractionBasedPreloadingStrategy } from './common/preload-strategy/InteractionBasedPreloadingStrategy';
import { LoadingCoordinatorService } from './common/services/loading-coordinator.service';

export const appConfig: ApplicationConfig = {
    providers: [
        LayoutBuilderService,
        LoadingCoordinatorService,
        PageBuilderService,
        PolygonHandlerService,
        PolygonLoopSeparatorService,
        { provide: LOCALE_ID, useValue: 'en-US' },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
            // withInMemoryScrolling({ anchorScrolling: 'enabled' }),
            withPreloading(InteractionBasedPreloadingStrategy),
            withViewTransitions(),
        ),
        provideLoadingBarRouter(),
        provideHttpClient(withFetch(), withInterceptors([AuthInterceptor])),
        provideClientHydration(
            withEventReplay(),
            withHttpTransferCacheOptions({
                includePostRequests: true,
                includeRequestsWithAuthHeaders: true,
            }),
        ),
        provideIcons(ICONS),
        provideNgIconsConfig({
            size: '24',
        }),
        provideNgIconLoader((name) => {
            const http = inject(HttpClient);
            return http.get(`assets/icons/${name}`, { responseType: 'text' });
        }, withCaching()),
        importProvidersFrom(NgxSkeletonLoaderModule.forRoot({ animation: 'pulse' })),
        {
            provide: ErrorHandler,
            useValue: createErrorHandler(),
        },
        DatePipe,
    ],
};
